module.exports = __webpack_public_path__ + "static/media/btrade.2fc40d08.png";